<input type="url" bind:value={value} size={40} maxlength={200} />

<script lang="ts">
  export let value: string; /* in/out */
</script>
